import React, { useState, useEffect } from 'react';
import {ClockCircleOutlined} from 'components/shared/AntIcons';

const LinkExpired: React.FC = () => {
    return (
        <div className='bg-light h-100 d-flex align-items-center justify-content-center'>
            <div className='container mx-auto w-50 text-center'>
                <ClockCircleOutlined className='text-danger fs-50' />
                <h3 className='mt-3'>Link has expired</h3>
                <p className='text-muted mt-3'>This consent form link is no longer valid.</p>
                <p className='text-muted'>For security purposes, consent links expire after a set period. Please request a new link to proceed.</p>
                <div className='mt-4'>

                </div>
            </div>
        </div>
    )
}

export default LinkExpired;